import { useState } from "react";
import { Menu, X, Lock } from "lucide-react";
import { ASSETS, NAV_LINKS } from "@/data/content";
import { img } from "@/data/images";
import { AudioToggle } from "@/components/site/AudioToggle";

export default function Nav({ vis = {} }) {
  const [open, setOpen] = useState(false);
  const links = NAV_LINKS.filter((l) => !(l.social && vis.social === false));

  return (
    <nav className="nv-bar fixed top-0 inset-x-0 z-50" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-5 py-5 flex items-center justify-between relative gap-4">
        {/* Left: logo */}
        <a href="#top" className="flex items-center shrink-0" data-testid="nav-logo">
          <img src={img("logoGate", ASSETS.logoGate)} alt="GATE ESCAPE" className="h-14 sm:h-16 w-auto glow-nv" />
        </a>

        {/* Center brand */}
        <div className="absolute left-1/2 -translate-x-1/2 pointer-events-none hidden sm:block">
          <span className="font-head text-3xl lg:text-4xl tracking-[0.4em] text-nv flicker" data-testid="nav-brand">
            HUBERT
          </span>
        </div>

        {/* Right: audio + hamburger (vždy) */}
        <div className="flex items-center gap-3 shrink-0">
          <AudioToggle />
          <button onClick={() => setOpen(!open)} data-testid="nav-toggle" className="text-neutral-100 p-2">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="bg-black/95 border-t border-nv/20 px-5 py-4 flex flex-col gap-4" data-testid="nav-mobile">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label}`} onClick={() => setOpen(false)}
              className={`text-sm tracking-[0.2em] uppercase ${l.cta ? "text-nv font-head" : "text-neutral-300 hover:text-nv"} transition-colors`}>
              {l.label}
            </a>
          ))}
          <a href="/admin" onClick={() => setOpen(false)} className="text-xs text-neutral-500 tracking-widest flex items-center gap-2 hover:text-nv">
            <Lock className="w-3 h-3" /> ADMIN
          </a>
        </div>
      )}
    </nav>
  );
}
